import { useCallback } from 'react';
import { formatGraphqlErrors } from 'utils/helpers';
import { useMutation } from '@apollo/client/react';
import {
  type UpdatePlanItemMutationVariables,
  UpdatePlanItemDocument,
  ProjectPlanDocument,
} from 'graphql/generated/graphql';

const useUpdatePlanItem = () => {
  const [updatePlanItemMutation] = useMutation(UpdatePlanItemDocument);

  const updatePlanItem = useCallback(
    async ({
      projectId,
      categoryName,
      planItemName,
      formData,
    }: UpdatePlanItemMutationVariables) => {
      try {
        await updatePlanItemMutation({
          variables: { projectId, categoryName, planItemName, formData },
          refetchQueries: [{ query: ProjectPlanDocument, variables: { projectId } }],
          awaitRefetchQueries: true,
        });
      } catch (error) {
        const e = formatGraphqlErrors(error);
        throw e;
      }
    },
    [updatePlanItemMutation],
  );
  return updatePlanItem;
};

export default useUpdatePlanItem;
